/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


/* ============= Footer Acordion =============  */
const footerLinkMenu = document.querySelectorAll("button.footer__item-title");
function footerToggle() {
  const content = this.nextElementSibling;
  this.classList.toggle("is-active");
  content.classList.toggle("is-open");
}

for (let i = 0; i < footerLinkMenu.length; i++) {
  footerLinkMenu[i].addEventListener("click", footerToggle);
}

const footerNestedToggles = document.querySelectorAll(".footer__link-toggle");
function footerNestedToggle() {
  const content = this.nextElementSibling;
  const isOpen = this.classList.toggle("is-active");
  this.setAttribute("aria-expanded", isOpen ? "true" : "false");
  if (content) content.classList.toggle("is-open");
}

for (let i = 0; i < footerNestedToggles.length; i++) {
  footerNestedToggles[i].addEventListener("click", footerNestedToggle);
}


/* ============= Page Top =============  */
document.addEventListener("DOMContentLoaded", () => {
  const pageTopBtns = document.querySelectorAll('[data-action="page-top"]');
  if (!pageTopBtns.length) return;

  const SHOW_OFFSET = 200;
  const toggleVisibility = () => {
    const isVisible = window.scrollY > SHOW_OFFSET;
    pageTopBtns.forEach((btn) => {
      btn.classList.toggle("is-visible", isVisible);
    });
  };

  document.addEventListener("click", (e) => {
    const btn = e.target.closest('[data-action="page-top"]');
    if (!btn) return;
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });

  window.addEventListener("scroll", toggleVisibility, { passive: true });
  toggleVisibility();
});


/* ============= Custom Acordion =============  */
/* イベント委譲: 再描画後に追加された .c-acordion__toggle も動作する */
document.addEventListener("click", function (e) {
  var toggleEl = e.target.closest(".c-acordion__toggle");
  if (!toggleEl) return;
  var content = toggleEl.nextElementSibling;
  if (!content) return;
  toggleEl.classList.toggle("is-active");
  content.classList.toggle("is-open");
});

/* ============= Mobile Menu (drill-down) =============  */
(function () {
  function resetMobileMenuAccordions(menu) {
    menu.querySelectorAll(".c-mobile-menu__accordion[open]").forEach(function (el) {
      el.removeAttribute("open");
    });
  }

  function showMobileMenuPanel(menu, panelId) {
    if (!menu || !panelId) return;

    menu.querySelectorAll(".c-mobile-menu__panel").forEach(function (panel) {
      var isActive = panel.getAttribute("data-panel-id") === panelId;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });

    menu.querySelectorAll("[data-mobile-menu-open]").forEach(function (btn) {
      btn.setAttribute(
        "aria-expanded",
        btn.getAttribute("data-mobile-menu-open") === panelId ? "true" : "false"
      );
    });

    menu.scrollTop = 0;
  }

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-mobile-menu-open]");
    if (openBtn) {
      var openMenu = openBtn.closest("[data-mobile-menu]");
      if (!openMenu) return;
      e.preventDefault();
      showMobileMenuPanel(openMenu, openBtn.getAttribute("data-mobile-menu-open"));
      return;
    }

    var backBtn = e.target.closest("[data-mobile-menu-back]");
    if (!backBtn) return;

    var panel = backBtn.closest(".c-mobile-menu__panel");
    var backMenu = backBtn.closest("[data-mobile-menu]");
    if (!panel || !backMenu) return;

    e.preventDefault();
    showMobileMenuPanel(backMenu, panel.getAttribute("data-parent-panel") || "root");
  });

  document.addEventListener("mobile-nav:close", function (e) {
    var menu = e.target.querySelector("[data-mobile-menu]");
    if (!menu) return;
    showMobileMenuPanel(menu, "root");
    resetMobileMenuAccordions(menu);
  });

  document.addEventListener("openable-element:close", function (e) {
    var menu = e.target.querySelector("[data-mobile-menu]");
    if (!menu) return;
    showMobileMenuPanel(menu, "root");
    resetMobileMenuAccordions(menu);
  });
})();

/* ============= Custom Tab =============  */
/* イベント委譲: DOMContentLoaded 後に追加・再描画された .c-tab も動作する */
document.addEventListener('click', function (e) {
  var tab = e.target.closest('.c-tab');
  if (!tab) return;
  var ancestorEle = tab.closest('.c-tab-panel');
  if (!ancestorEle) return;

  var activeEls = ancestorEle.getElementsByClassName('is-active');
  if (activeEls.length) activeEls[0].classList.remove('is-active');
  tab.classList.add('is-active');

  var showEls = ancestorEle.getElementsByClassName('is-show');
  if (showEls.length) showEls[0].classList.remove('is-show');

  var groupTabs = ancestorEle.getElementsByClassName('c-tab');
  var arrayTabs = Array.prototype.slice.call(groupTabs);
  var index = arrayTabs.indexOf(tab);
  var panels = ancestorEle.getElementsByClassName('c-panel');
  if (index >= 0 && panels[index]) {
    panels[index].classList.add('is-show');
  }
});



/* ============= Custom Modal ============= */
(function() {
  'use strict';

  function getModalToggles(modalId) {
    if (!modalId) {
      return [];
    }
    return Array.from(document.querySelectorAll(`[aria-controls="${CSS.escape(modalId)}"]`));
  }

  function syncModalToggleExpanded(modal, expanded) {
    if (!modal.id) {
      return;
    }
    getModalToggles(modal.id).forEach((toggle) => {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  document.addEventListener('openable-element:open', function(event) {
    if (event.target.tagName.toLowerCase() !== 'modal-content' || !event.target.classList.contains('c-modal')) {
      return;
    }
    syncModalToggleExpanded(event.target, true);
  });

  document.addEventListener('openable-element:close', function(event) {
    if (event.target.tagName.toLowerCase() !== 'modal-content' || !event.target.classList.contains('c-modal')) {
      return;
    }
    syncModalToggleExpanded(event.target, false);
  });

  document.addEventListener('click', function(event) {
    let toggle = event.target.closest('.c-modal-toggle');
    if (!toggle) {
      const candidate = event.target.closest('[aria-controls]');
      if (candidate) {
        const candidateModalId = candidate.getAttribute('aria-controls');
        const candidateModal = candidateModalId && document.getElementById(candidateModalId);
        if (candidateModal && candidateModal.tagName.toLowerCase() === 'modal-content' && candidateModal.classList.contains('c-modal')) {
          toggle = candidate;
        }
      }
    }
    if (!toggle) {
      return;
    }

    if (toggle.getAttribute('is') === 'toggle-button' && !toggle.classList.contains('c-modal-toggle')) {
      return;
    }

    let modal = null;
    const modalId = toggle.getAttribute('aria-controls');
    if (modalId) {
      const target = document.getElementById(modalId);
      if (target && target.tagName.toLowerCase() === 'modal-content' && target.classList.contains('c-modal')) {
        modal = target;
      }
    }
    if (!modal && toggle.classList.contains('c-modal-toggle')) {
      const sibling = toggle.nextElementSibling;
      if (sibling && sibling.tagName.toLowerCase() === 'modal-content' && sibling.classList.contains('c-modal')) {
        modal = sibling;
      }
    }
    if (!modal) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    modal.open = !modal.open;
  }, { passive: false });
})();

/* ============= Product Media Column2 Zoom ============= */
(function() {
  'use strict';

  var DESKTOP_MQ = '(min-width: 1000px)';

  function initZoomHintFollow(media) {
    if (media.dataset.zoomHintFollowInit) {
      return;
    }

    media.dataset.zoomHintFollowInit = 'true';

    function updateHintPosition(event) {
      if (!window.matchMedia(DESKTOP_MQ).matches) {
        return;
      }

      var item = event.target.closest('.product__media-item[data-media-type="image"]:not(.is-filtered)');
      if (!item || !media.contains(item)) {
        return;
      }

      var wrapper = item.querySelector('.product__media-image-wrapper');
      var hint = wrapper && wrapper.querySelector('.product__media-zoom-hint');
      if (!hint) {
        return;
      }

      var rect = wrapper.getBoundingClientRect();
      hint.style.left = (event.clientX - rect.left) + 'px';
      hint.style.top = (event.clientY - rect.top) + 'px';
    }

    media.addEventListener('mousemove', updateHintPosition);
    media.addEventListener('mouseover', updateHintPosition);
  }

  function initAllZoomHintFollow() {
    document.querySelectorAll('.product__media--column2-pc').forEach(initZoomHintFollow);
  }

  document.addEventListener('click', function(event) {
    if (!window.matchMedia(DESKTOP_MQ).matches) {
      return;
    }

    var media = event.target.closest('.product__media--column2-pc');
    if (!media) {
      return;
    }

    var item = event.target.closest('.product__media-item[data-media-type="image"]:not(.is-filtered)');
    if (!item || !media.contains(item)) {
      return;
    }

    var zoom = media.querySelector('product-image-zoom');
    if (!zoom) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    media.querySelectorAll('.product__media-item.is-selected').forEach(function(selected) {
      selected.classList.remove('is-selected');
    });
    item.classList.add('is-selected');

    zoom.open = true;
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllZoomHintFollow);
  } else {
    initAllZoomHintFollow();
  }
})();

/* ============= Product Media Alt Color Filter ============= */
(function() {
  'use strict';

  var HIDE_KEYWORDS = ['hidden', 'thumbnail'];

  function getVariantOptionValue(variant, colorOptionIndex) {
    if (!variant) {
      return '';
    }

    if (variant.options && variant.options[colorOptionIndex] != null) {
      return String(variant.options[colorOptionIndex]).trim();
    }

    var optionKey = 'option' + (colorOptionIndex + 1);
    if (variant[optionKey] != null) {
      return String(variant[optionKey]).trim();
    }

    return '';
  }

  function getPreferredMediaId(variant) {
    if (!variant) {
      return null;
    }
    if (variant.featured_media && variant.featured_media.id) {
      return variant.featured_media.id;
    }
    if (variant.featured_image && variant.featured_image.id) {
      return variant.featured_image.id;
    }
    return null;
  }

  function getColorNames(mediaElement) {
    try {
      var raw = mediaElement.getAttribute('data-color-names') || '[]';
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.map(function(name) {
        return String(name || '').trim();
      }).filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  /*
  function getAltColor(alt) {
    if (!alt || alt.indexOf(',') === -1) {
      return '';
    }
    return alt.split(',').slice(1).join(',').trim();
  }
    */
  function getAltColor(alt) {
    return String(alt || '').trim();
  }

  function shouldHideMedia(alt, selectedColor, colorCount, colorNames, mediaType) {
    var mediaAlt = alt || '';
    var mediaAltLower = mediaAlt.toLowerCase();

    if (HIDE_KEYWORDS.some(function(keyword) {
      return mediaAltLower.indexOf(keyword) !== -1;
    })) {
      return true;
    }

    // Shared MP4 / external videos stay visible for every color
    if (mediaType === 'video' || mediaType === 'external_video') {
      return false;
    }

    if (!(colorCount > 1 && selectedColor)) {
      return false;
    }

    var altColor = getAltColor(mediaAlt);
    if (!altColor) {
      return false;
    }

    if (altColor === selectedColor) {
      return false;
    }

    return colorNames.some(function(colorName) {
      return colorName && colorName !== selectedColor && altColor === colorName;
    });
  }

  function collectFilteredIds(mediaElement, selectedColor) {
    var colorCount = parseInt(mediaElement.getAttribute('data-color-count'), 10) || 0;
    var colorNames = getColorNames(mediaElement);
    var filteredIds = [];

    mediaElement.querySelectorAll('.product__media-item[data-media-id]').forEach(function(item) {
      var mediaId = parseInt(item.getAttribute('data-media-id'), 10);
      var alt = item.getAttribute('data-media-alt') || '';
      var mediaType = item.getAttribute('data-media-type') || '';
      if (shouldHideMedia(alt, selectedColor, colorCount, colorNames, mediaType)) {
        filteredIds.push(mediaId);
      }
    });

    return filteredIds;
  }

  function isColumn2Desktop(mediaElement) {
    return (
      mediaElement.classList.contains('product__media--column2-pc') &&
      window.matchMedia('(min-width: 1000px)').matches
    );
  }

  function playVisibleVideos(mediaElement) {
    if (!mediaElement.hasAttribute('autoplay-video')) {
      return;
    }

    mediaElement
      .querySelectorAll(
        '.product__media-item:not(.is-filtered)[data-media-type="video"], .product__media-item:not(.is-filtered)[data-media-type="external_video"]'
      )
      .forEach(function(item) {
        var player = item.firstElementChild;
        if (player && typeof player.play === 'function') {
          try {
            player.play();
          } catch (error) {
            // Ignore autoplay rejection; muted autoplay usually succeeds.
          }
        }
      });
  }

  function initColumn2VideoAutoplay(mediaElement) {
    if (!mediaElement.classList.contains('product__media--column2-pc')) {
      return;
    }
    if (!mediaElement.hasAttribute('autoplay-video')) {
      return;
    }
    if (mediaElement.dataset.column2VideoReady === 'true') {
      return;
    }
    mediaElement.dataset.column2VideoReady = 'true';

    var replayVisibleVideos = function() {
      if (!isColumn2Desktop(mediaElement)) {
        return;
      }
      // Theme pauses all videos on slide change; re-play every visible cell in the grid.
      requestAnimationFrame(function() {
        playVisibleVideos(mediaElement);
      });
    };

    replayVisibleVideos();

    var carousel = mediaElement.querySelector('flickity-carousel');
    if (!carousel) {
      return;
    }

    carousel.addEventListener('flickity:ready', replayVisibleVideos);
    carousel.addEventListener('flickity:slide-changed', replayVisibleVideos);
    carousel.addEventListener('flickity:slide-settled', replayVisibleVideos);
  }

  async function applyAltColorFilter(mediaElement, selectedColor, preferredMediaId) {
    var scrollY = window.scrollY || window.pageYOffset || 0;
    var filteredIds = collectFilteredIds(mediaElement, selectedColor);
    var currentlyFilteredIds = Array.from(
      new Set(
        Array.from(mediaElement.querySelectorAll('.product__media-item.is-filtered[data-media-id]')).map(function(item) {
          return parseInt(item.getAttribute('data-media-id'), 10);
        })
      )
    );

    var filterChanged =
      currentlyFilteredIds.length !== filteredIds.length ||
      currentlyFilteredIds.some(function(id) {
        return filteredIds.indexOf(id) === -1;
      }) ||
      filteredIds.some(function(id) {
        return currentlyFilteredIds.indexOf(id) === -1;
      });

    var visibleIds = Array.from(mediaElement.querySelectorAll('.product__media-item[data-media-id]'))
      .map(function(item) {
        return parseInt(item.getAttribute('data-media-id'), 10);
      })
      .filter(function(id) {
        return filteredIds.indexOf(id) === -1;
      });

    var selectedMediaId =
      preferredMediaId && visibleIds.indexOf(preferredMediaId) !== -1
        ? preferredMediaId
        : visibleIds[0] || null;

    var isColumn2DesktopLayout = isColumn2Desktop(mediaElement);

    mediaElement.querySelectorAll('[data-media-id]').forEach(function(item) {
      var mediaId = parseInt(item.getAttribute('data-media-id'), 10);
      var isFiltered = filteredIds.indexOf(mediaId) !== -1;
      var isSelected = selectedMediaId === mediaId;

      item.classList.toggle('is-filtered', isFiltered);

      if (isColumn2DesktopLayout) {
        if (item.classList.contains('product__media-item')) {
          item.classList.toggle('is-selected', !isFiltered);
          item.classList.toggle('is-initial-selected', !isFiltered);
        } else if (item.matches('.product__thumbnail-item, .dots-nav__item')) {
          item.classList.toggle('is-selected', isSelected);
          if (isSelected) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        }
        return;
      }

      item.classList.toggle('is-selected', isSelected);
      item.classList.toggle('is-initial-selected', isSelected);
      if (item.matches('.product__thumbnail-item, .dots-nav__item')) {
        if (isSelected) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      }
    });

    var flickityCarousel = mediaElement.querySelector('flickity-carousel');
    if (!flickityCarousel) {
      restoreScrollPosition(scrollY);
      return;
    }

    if (isColumn2DesktopLayout) {
      if (filterChanged && typeof flickityCarousel.reload === 'function') {
        await flickityCarousel.reload();

        mediaElement.querySelectorAll('.product__media-item[data-media-id]').forEach(function(item) {
          var mediaId = parseInt(item.getAttribute('data-media-id'), 10);
          var isFiltered = filteredIds.indexOf(mediaId) !== -1;
          item.classList.toggle('is-filtered', isFiltered);
          item.classList.toggle('is-selected', !isFiltered);
          item.classList.toggle('is-initial-selected', !isFiltered);
        });
      }
      playVisibleVideos(mediaElement);
      restoreScrollPosition(scrollY);
      return;
    }

    if (filterChanged) {
      if (flickityCarousel.flickityInstance) {
        var instance = await flickityCarousel.flickityInstance;
        if (instance && typeof instance.destroy === 'function') {
          instance.destroy();
        }
      }
      if (typeof flickityCarousel.reload === 'function') {
        await flickityCarousel.reload();
      }
    } else if (selectedMediaId && typeof flickityCarousel.select === 'function') {
      await flickityCarousel.select('[data-media-id="' + selectedMediaId + '"]');
    }

    restoreScrollPosition(scrollY);
  }

  function restoreScrollPosition(scrollY) {
    if (typeof scrollY !== 'number') {
      return;
    }

    var applyScroll = function() {
      window.scrollTo(0, scrollY);
    };

    applyScroll();
    requestAnimationFrame(applyScroll);
  }

  function onVariantChanged(mediaElement, event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) {
      return;
    }

    var colorOptionIndex = parseInt(mediaElement.getAttribute('data-color-option-index'), 10);
    var selectedColor = getVariantOptionValue(variant, colorOptionIndex);
    if (!selectedColor) {
      return;
    }

    applyAltColorFilter(
      mediaElement,
      selectedColor,
      getPreferredMediaId(variant)
    ).catch(function() {});
  }

  function initAltColorFilter(mediaElement) {
    if (mediaElement.dataset.altColorFilterReady === 'true') {
      return;
    }
    mediaElement.dataset.altColorFilterReady = 'true';

    var productFormId = mediaElement.getAttribute('form-id');
    var form = document.getElementById(productFormId) || document.forms[productFormId];
    if (!form) {
      return;
    }

    var savedScrollY = 0;

    form.addEventListener(
      'variant:change',
      function() {
        savedScrollY = window.scrollY || window.pageYOffset || 0;
      },
      true
    );

    form.addEventListener('variant:changed', function(event) {
      onVariantChanged(mediaElement, event);
    });

    form.addEventListener('product:rerender', function() {
      restoreScrollPosition(savedScrollY);
    });
  }

  function initAllAltColorFilters() {
    document.querySelectorAll('product-media[data-alt-color-filter]').forEach(initAltColorFilter);
  }

  function initAllColumn2VideoAutoplay() {
    document.querySelectorAll('product-media.product__media--column2-pc[autoplay-video]').forEach(initColumn2VideoAutoplay);
  }

  function initProductMediaExtras() {
    initAllAltColorFilters();
    initAllColumn2VideoAutoplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductMediaExtras);
  } else {
    initProductMediaExtras();
  }

  document.addEventListener('shopify:section:load', initProductMediaExtras);
})();


/* ============= Yotpo widget preserve on variant change ============= */
(function() {
  'use strict';

  var YOTPO_SELECTOR = '.product-meta .yotpo-widget-instance';

  function getProductRerender(scope) {
    if (scope && scope.closest) {
      return scope.closest('product-rerender');
    }
    return null;
  }

  function getYotpoWidget(scope) {
    var rerenderRoot = getProductRerender(scope);
    return rerenderRoot ? rerenderRoot.querySelector(YOTPO_SELECTOR) : null;
  }

  function refreshYotpoWidgets(scope) {
    var root = scope || document;
    if (!root.querySelector('.yotpo-widget-instance')) {
      return;
    }

    if (
      window.yotpoWidgetsContainer &&
      typeof window.yotpoWidgetsContainer.initWidgets === 'function'
    ) {
      window.yotpoWidgetsContainer.initWidgets();
      return;
    }

    if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
      window.yotpo.initWidgets();
    }
  }

  function initYotpoPreserve(form) {
    if (form.dataset.yotpoPreserveInit === 'true') {
      return;
    }
    form.dataset.yotpoPreserveInit = 'true';

    form.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.productChange) {
        form._yotpoPreserve = null;
        return;
      }

      var widget = getYotpoWidget(form);
      if (!widget || !widget.hasAttribute('data-yotpo-element-loaded')) {
        form._yotpoPreserve = null;
        return;
      }

      form._yotpoPreserve = widget;
      widget.remove();
    });

    form.addEventListener('product:rerender', function(event) {
      var preserved = form._yotpoPreserve;

      if (event.detail && event.detail.productChange) {
        form._yotpoPreserve = null;
        requestAnimationFrame(function() {
          refreshYotpoWidgets(getProductRerender(form) || form);
        });
        return;
      }

      if (preserved) {
        var placeholder = getYotpoWidget(form);
        if (placeholder && placeholder !== preserved) {
          placeholder.replaceWith(preserved);
        }
        form._yotpoPreserve = null;
        return;
      }

      requestAnimationFrame(function() {
        refreshYotpoWidgets(getProductRerender(form) || form);
      });
    });
  }

  function bootYotpoPreserve() {
    document
      .querySelectorAll('form[is="product-form"], form.shopify-product-form')
      .forEach(initYotpoPreserve);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootYotpoPreserve);
  } else {
    bootYotpoPreserve();
  }

  document.addEventListener('shopify:section:load', function(event) {
    event.target
      .querySelectorAll('form[is="product-form"], form.shopify-product-form')
      .forEach(initYotpoPreserve);
    refreshYotpoWidgets(event.target);
  });
})();


/**
 * MultiLikes product wishlist Button
 */
(function() {
  var DEFAULT_ENDPOINT = '/apps/multilikes-endpoint';
  var LOGIN_MODAL_ID = 'c-wishlist-login-modal';

  function getButtons() {
    return Array.from(document.querySelectorAll('[data-wishlist-button]'));
  }

  function getCurrentVariantId(button) {
    if (!button) return '';

    // 商品カード内は必ずカード内だけを参照（一覧で他商品の form id を拾わない）
    var item = button.closest('product-item');
    if (item) {
      var checkedSwatch = item.querySelector('.color-swatch__radio:checked[data-variant-id]');
      if (checkedSwatch) {
        return String(checkedSwatch.getAttribute('data-variant-id'));
      }
      var itemInput = item.querySelector(
        'form.shopify-product-form input[name="id"], form[is="product-form"] input[name="id"]'
      );
      if (itemInput && itemInput.value) {
        return String(itemInput.value);
      }
      return String(button.getAttribute('data-variant-id') || '');
    }

    // 商品詳細: 同一フォーム内の id を優先
    var form =
      button.closest('form.shopify-product-form, form[is="product-form"]') ||
      button.closest('.product-form');
    if (form) {
      var formInput = form.querySelector('input[name="id"]');
      if (formInput && formInput.value) {
        return String(formInput.value);
      }
      // .product-form ラッパー配下の product form
      var nestedInput = form.querySelector(
        'form.shopify-product-form input[name="id"], form[is="product-form"] input[name="id"]'
      );
      if (nestedInput && nestedInput.value) {
        return String(nestedInput.value);
      }
    }

    return String(button.getAttribute('data-variant-id') || '');
  }

  function syncButtonsVariantId(variantId, scope) {
    if (!variantId) return;
    var root = scope || document;
    var buttons = root.querySelectorAll
      ? root.querySelectorAll('[data-wishlist-button]')
      : getButtons();
    Array.from(buttons).forEach(function(button) {
      button.setAttribute('data-variant-id', String(variantId));
    });
  }

  function setActiveState(button, isActive) {
    button.classList.toggle('is-active', Boolean(isActive));
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  }

  function openLoginModal(button) {
    var modal = document.getElementById(LOGIN_MODAL_ID);
    if (!modal) {
      console.warn('[wishlist] login modal not found:', LOGIN_MODAL_ID);
      return;
    }
    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }
    modal.open = true;
  }

  function buildUrl(endpoint, params) {
    var url = new URL(endpoint, window.location.origin);
    Object.keys(params).forEach(function(key) {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        url.searchParams.set(key, String(params[key]));
      }
    });
    return url.toString();
  }

  function parseJsonResponse(response) {
    return response.text().then(function(text) {
      var payload = null;
      try {
        payload = text ? JSON.parse(text) : null;
      } catch (err) {
        throw new Error('Invalid JSON (' + response.status + '): ' + text.slice(0, 200));
      }
      if (!response.ok) {
        throw new Error((payload && payload.error) || ('HTTP ' + response.status));
      }
      if (payload && payload.error) {
        throw new Error(payload.error);
      }
      return payload;
    });
  }

  function fetchStatus(button) {
    var customerId = button.getAttribute('data-customer-id');
    if (!customerId) return;

    var endpoint = button.getAttribute('data-api-endpoint') || DEFAULT_ENDPOINT;
    var productId = button.getAttribute('data-product-id');
    var variantId = getCurrentVariantId(button);
    if (!productId || !variantId) return;

    var url = buildUrl(endpoint, {
      target_type: 'product',
      product_id: productId,
      variant_id: variantId,
      customer_id: customerId
    });

    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(parseJsonResponse)
      .then(function(payload) {
        var data = payload && payload.data ? payload.data : {};
        setActiveState(button, Boolean(data.isInWishlist));
      })
      .catch(function(err) {
        console.warn('[wishlist] status failed', err);
      });
  }

  function toggleWishlist(button) {
    var customerId = button.getAttribute('data-customer-id');
    if (!customerId) {
      openLoginModal(button);
      return;
    }

    if (button.getAttribute('data-wishlist-loading') === 'true') return;

    var endpoint = button.getAttribute('data-api-endpoint') || DEFAULT_ENDPOINT;
    var productId = button.getAttribute('data-product-id');
    var variantId = getCurrentVariantId(button);
    if (!productId || !variantId) {
      console.warn('[wishlist] missing product/variant id', { productId: productId, variantId: variantId });
      return;
    }

    // クリック時点の variant をボタンへ確定
    button.setAttribute('data-variant-id', variantId);

    var wasActive = button.classList.contains('is-active');
    var action = wasActive ? 'remove' : 'add';
    var params = {
      target_type: 'product',
      customer_id: customerId,
      action: action,
      product_id: productId,
      variant_id: variantId
    };
    var body = new URLSearchParams(params);
    // App Proxy 向けに query にも同パラメータを載せる
    var url = buildUrl(endpoint, params);

    button.setAttribute('data-wishlist-loading', 'true');
    button.setAttribute('aria-busy', 'true');
    // 楽観的更新（失敗時に戻す）
    setActiveState(button, action === 'add');

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: body.toString()
    })
      .then(parseJsonResponse)
      .then(function(payload) {
        var data = payload && payload.data ? payload.data : {};
        if (typeof data.isInWishlist === 'boolean') {
          setActiveState(button, data.isInWishlist);
        }
      })
      .catch(function(err) {
        console.error('[wishlist] toggle failed', err);
        setActiveState(button, wasActive);
      })
      .then(function() {
        button.setAttribute('data-wishlist-loading', 'false');
        button.removeAttribute('aria-busy');
      });
  }

  function refreshAllStatuses(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll
      ? root.querySelectorAll('[data-wishlist-button]')
      : getButtons();
    Array.from(buttons).forEach(function(button) {
      fetchStatus(button);
    });
  }

  function onVariantIdChanged(variantId, scope) {
    syncButtonsVariantId(variantId, scope);
    refreshAllStatuses(scope);
  }

  function initWishlistButtons(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll
      ? root.querySelectorAll('[data-wishlist-button]')
      : getButtons();
    Array.from(buttons).forEach(function(button) {
      fetchStatus(button);
    });
  }

  // イベント委譲（再描画後もクリック可能）
  document.addEventListener(
    'click',
    function(event) {
      var button = event.target && event.target.closest
        ? event.target.closest('[data-wishlist-button]')
        : null;
      if (!button) return;
      event.preventDefault();
      // aria-controls がある場合の共通モーダル document ハンドラのトグルを防ぐ
      event.stopPropagation();
      toggleWishlist(button);
    },
    true
  );

  document.addEventListener('change', function(event) {
    if (!event.target || !event.target.matches) return;

    // 商品カードのカラースウォッチ変更時は対象 variant を同期
    if (event.target.matches('.product-item .color-swatch__radio')) {
      var variantId = event.target.getAttribute('data-variant-id');
      var item = event.target.closest('product-item');
      if (!item || !variantId) return;
      var wishlistButton = item.querySelector('[data-wishlist-button]');
      if (!wishlistButton) return;
      wishlistButton.setAttribute('data-variant-id', String(variantId));
      fetchStatus(wishlistButton);
      return;
    }

    if (!event.target.matches('.shopify-product-form input[name="id"], form[is="product-form"] input[name="id"]')) {
      return;
    }
    var scope = event.target.form || event.target.closest('.product-form') || document;
    onVariantIdChanged(event.target.value, scope);
  });

  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;
    var scope = event.target && event.target.closest
      ? event.target.closest('.product-form') || event.target
      : document;
    onVariantIdChanged(variant.id, scope);
  });

  function boot() {
    initWishlistButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initWishlistButtons(event.target);
  });

  // 絞り込み・ページネーション等で product-item が差し替わった後に状態を再取得
  var wishlistRefreshTimer = null;
  function scheduleWishlistRefresh(root) {
    clearTimeout(wishlistRefreshTimer);
    wishlistRefreshTimer = setTimeout(function() {
      initWishlistButtons(root || document);
    }, 50);
  }

  document.addEventListener('facet:criteria-changed', function() {
    scheduleWishlistRefresh(document.getElementById('facet-main') || document);
  });
  document.addEventListener('pagination:page-changed', function() {
    scheduleWishlistRefresh(document.getElementById('facet-main') || document);
  });

  if (typeof MutationObserver !== 'undefined') {
    var wishlistObserver = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!node || node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('[data-wishlist-button], product-item')) ||
            (node.querySelector && node.querySelector('[data-wishlist-button]'))
          ) {
            scheduleWishlistRefresh(node);
            return;
          }
        }
      }
    });
    wishlistObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ============= Product Size Guide ============= */
(function() {
  'use strict';

  function initSizingChart(root) {
    if (!root || root.dataset.sizingChartInit === 'true') {
      return;
    }
    root.dataset.sizingChartInit = 'true';

    root.querySelectorAll('[data-sizing-tab]').forEach(function(tabButton) {
      tabButton.addEventListener('click', function() {
        var tabName = tabButton.getAttribute('data-sizing-tab');
        var tabsRoot = tabButton.closest('.c-sizing-chart__tabs');
        if (!tabsRoot || !tabName) {
          return;
        }

        tabsRoot.querySelectorAll('.c-sizing-chart__tab').forEach(function(tab) {
          tab.classList.remove('is-active');
        });
        tabsRoot.querySelectorAll('[data-sizing-tab]').forEach(function(button) {
          button.setAttribute('aria-selected', 'false');
        });
        tabsRoot.querySelectorAll('[data-sizing-panel]').forEach(function(panel) {
          panel.classList.remove('is-active');
          panel.hidden = true;
        });

        tabButton.closest('.c-sizing-chart__tab').classList.add('is-active');
        tabButton.setAttribute('aria-selected', 'true');

        var activePanel = tabsRoot.querySelector('[data-sizing-panel="' + tabName + '"]');
        if (activePanel) {
          activePanel.classList.add('is-active');
          activePanel.hidden = false;
        }
      });
    });

    root.querySelectorAll('table.pop-sizing').forEach(function(table) {
      table.querySelectorAll('td').forEach(function(cell) {
        cell.addEventListener('mouseenter', function() {
          var colIndex = cell.cellIndex;
          cell.classList.add('is-highlight');
          if (cell.parentElement) {
            cell.parentElement.classList.add('is-hover');
          }
          var colgroup = table.querySelectorAll('colgroup')[colIndex];
          if (colgroup) {
            colgroup.classList.add('is-hover');
          }
        });

        cell.addEventListener('mouseleave', function() {
          var colIndex = cell.cellIndex;
          cell.classList.remove('is-highlight');
          if (cell.parentElement) {
            cell.parentElement.classList.remove('is-hover');
          }
          var colgroup = table.querySelectorAll('colgroup')[colIndex];
          if (colgroup) {
            colgroup.classList.remove('is-hover');
          }
        });
      });
    });
  }

  function initAllSizingCharts(scope) {
    (scope || document).querySelectorAll('[data-sizing-chart]').forEach(initSizingChart);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAllSizingCharts();
  });

  document.addEventListener('openable-element:open', function(event) {
    if (event.target.classList && event.target.classList.contains('c-modal--sizing')) {
      initAllSizingCharts(event.target);
    }
  });
})();
